export default [
    {
        text: "Afghanistan (+93)",
        value: "+93",
        flag: "af",
        key: "af"
    },
    {
        text: "Aland Islands",
        value: "",
        flag: "ax",
        key: "ax"
    },
    {
        text: "Albania (+355)",
        value: "+355",
        flag: "al",
        key: "al"
    }
]